// app/javascript/turbo_streams/toast.js
import { StreamActions } from "@hotwired/turbo"
import Toastify from "toastify-js"

StreamActions.toast = function() {
  const message = this.getAttribute("message")
  const position = this.getAttribute("position")
  Toastify({
    text: message,
    duration: 2000,
    destination: "",
    gravity: "top",
    position: position,
    stopOnFocus: true,
    className: "custom-toast"
  }).showToast()
}